@if(componentFormReady()) {
    <form autocomplete="off" [formGroup]="componentForm"
            class="form tw-p-5 tw-flex tw-flex-col tw-gap-5">
        <section class="tw-px-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-8">
                <mat-label translate>ITEMS.COMPONENTS.NAME</mat-label>
                <input matInput formControlName="name" appTrimInput>
                @if(isAlternativeTranslateEnabled) {
                    <mat-icon 
                        matIconSuffix
                        #tooltip_orderName="matTooltip"
                        class="tw-cursor-pointer tw-text-gray-500"
                        [matTooltip]="'ITEMS.ALTERNATIVE_TRANSLATE' | translate"
                        matTooltipPosition="above"
                        (click)="manageAlternativeTranslate()" 
                        aria-label="'ITEMS.ALTERNATIVE_TRANSLATE' | translate">
                        language_outlined
                    </mat-icon>
                }
                <mat-hint [align]="'end'">{{componentFormService.name?.value?.length || '0'}}
                    / {{componentFormService.validators.nameMaxLength}}</mat-hint>
                @if(componentFormService.name?.hasError('maxlength')) {
                    <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{componentFormService.validators.nameMaxLength}})</mat-error>
                } @else if(componentFormService.name?.hasError('required')) {
                    <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4">
                <mat-label translate>ITEMS.COMPONENTS.PRICE_DIFFERENCE</mat-label>
                <input matInput type="number" formControlName="price_difference">
            </mat-form-field>
    
            <div class="tw-col-span-12 tw-mt-4">
                <mat-label class="tw-text-[1.15rem] tw-font-medium" translate>ITEMS.COMPONENTS.ENABLE_CATEGORIES</mat-label>
            </div>
            <div class="tw-col-span-12 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-4 tw-p-3" 
             formArrayName="categories">
                @for(category of componentFormService.categoriesArray?.value; track i; let i = $index) {
                    <div [formGroupName]="i" [ngClass]="i === 0 ? 'tw-col-span-full' : 'tw-col-span-1'">
                        <mat-checkbox formControlName="checked"
                            [value]="category.id"
                            (change)="checkboxOptionSelectionChange($event)"
                        >{{category.name}}</mat-checkbox>
                    </div>
                }
            </div>
        </section>
    </form>
}